const HOME_PAGE = '/en-EN/index.html';
const LANGUAGE_DEFAULT = 'en';
const LANGUAGE_FALLBACK = 'en';
const MARKET_DEFAULT = 'EN';
const SUPPORTED_LANGUAGES = ['en', 'bg'];

export const CONF = {
    HOME_PAGE,
    LANGUAGE_DEFAULT,
    LANGUAGE_FALLBACK,
    MARKET_DEFAULT,
    SUPPORTED_LANGUAGES
};

// les différent thème du site
// correspond à la couleur du logo principal ainsi que du burger
export enum ETheme {
    LIGHT,
    DARK,
}

export enum EMenuIntro{
    DEFAULT,
    ARTICLE,
    ARTICLESIMPLE,
    POINTOFVIEW,
}